import { Injectable, OnInit } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Cookies } from './cookies';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class Service {
    private headers = new Headers({ 
        'Access-Control-Allow-Origin' : '*',
        'Content-Type': 'application/json;application/x-www-form-urlencoded'
    });

    //public urlBase = 'http://localhost:8000';
    public urlBase = 'http://190.69.197.70:8088';    

    constructor(private http: Http,private cookies:Cookies) {}

    LOGIN(data: Object): Observable<boolean> {
        return new Observable<boolean>(observe => {
            this.GetToken(JSON.stringify(data)).subscribe(res => {
                let token = res["token"];
                this.GetUser(data, token).subscribe(res => {
                    let data = res["user"];
                    data["token"] = token;
                    this.cookies.setCookie('ChamUserObject', data);
                    observe.next(true);
                    observe.complete();
                }, err => {
                    observe.error(err);
                    observe.complete();
                });

            }, err => {
                observe.error(err);
                observe.complete();
            });

        });
    }
    private GetToken(data: string): Observable<Object> {
        return this.http.post(`${this.urlBase}/api/authenticate`, data, { headers: this.headers })
            .map(res => { return res.json() })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'))
    }
    private GetUser(data: Object, token: string): Observable<Object> {
        return this.http.post(`${this.urlBase}/api/login?token=${token}`, JSON.stringify(data), { headers: this.headers })
            .map(res => { return res.json() })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    POST(url: string, data: Object): Observable<Object> {
        let cook = this.cookies.getCookie('ChamUserObject');
        return this.http.post(`${this.urlBase}/api/${url}?token=${cook["token"]}`, JSON.stringify(data), { headers: this.headers })
            .map(res => { return res.json() })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    GET(url: string, data: string): Observable<Object> {
        let cook = this.cookies.getCookie('ChamUserObject');
        return this.http.get(`${this.urlBase}/api/${url}?token=${cook["token"]}${data}`)
            .map(res => { return res.json() })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    PUT(url: string, data: Object): Observable<Object> {
        let cook = this.cookies.getCookie('ChamUserObject');
        return this.http.put(`${this.urlBase}/api/${url}?token=${cook["token"]}`, JSON.stringify(data), { headers: this.headers })
            .map(res => { return res.json(); })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    DELETE(url: string): Observable<Object> {
        let cook = this.cookies.getCookie('ChamUserObject');
        return this.http.delete(`${this.urlBase}/api/${url}?token=${cook["token"]}`, { headers: this.headers })
            .map(res => { return res.json(); })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    PRIVILEGES(userprofile_id: number, view: string): Observable<Object> {
        let cook = this.cookies.getCookie('ChamUserObject');
        return this.http.post(`${this.urlBase}/api/getPrivileges?token=${cook["token"]}`, { data: JSON.stringify({ userprofile_id: userprofile_id, view: view }) }, { headers: this.headers })
            .map(res => { return res.json(); })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// ./src/app/class/service.ts